import { Configuration } from '../../../model/Configuration'

const CONFIGURATION_CHANGE = 'CONFIGURATION/CHANGE';

export default function configurationChangeAction (config: Configuration) {
  return {
    type: CONFIGURATION_CHANGE,
    payload: { 
        configuration: config
     }
  };
}

export { CONFIGURATION_CHANGE };